import { Box } from './../components/layout/Grid';
import BaseSkeleton from './BaseSkeleton';

const VideoSingleMetadataSkeleton = props => (
  <>
    <Box
      display="flex"
      flexDirection={['column', 'column', 'row']}
      alignItems={['flex-start', 'flex-start', 'center']}
    >
      <Box width="100%" mr={40}>
        <BaseSkeleton
          shape={'square'}
          height={25}
          width={100}
          borderRadius="3px"
          animation={props.animation}
        />
      </Box>

      <Box width="40%" alignItems="center" height={45} display="flex">
        <BaseSkeleton
          borderRadius="2px"
          height={20}
          animation={props.animation}
        />

        <Box width={[0, 0, 65]} height={45} ml={20}>
          <BaseSkeleton
            borderRadius="45px"
            height={45}
            width={100}
            animation={props.animation}
          />
        </Box>
      </Box>
    </Box>

    <Box display="flex" alignItems="center" mt={40}>
      <Box width={200}>
        <BaseSkeleton height={45} width={100} animation={props.animation} />
      </Box>
      <Box width={200} ml={20}>
        <BaseSkeleton height={45} width={100} animation={props.animation} />
      </Box>
    </Box>

    <Box mt={50} width={['100%', '100%', '30%']}>
      <BaseSkeleton
        height={30}
        width={100}
        marginBottom={10}
        animation={props.animation}
      />
      <BaseSkeleton
        height={30}
        marginBottom={10}
        width={100}
        animation={props.animation}
      />
      <BaseSkeleton
        height={30}
        marginBottom={10}
        width={100}
        animation={props.animation}
      />
    </Box>
  </>
);

export default VideoSingleMetadataSkeleton;
